import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { RxFormGroup } from '@rxweb/reactive-form-validators';

@Component({
  selector: 'app-input-check',
  templateUrl: './input-check.component.html',
  styleUrls: ['./input-check.component.scss']
})
export class InputCheckComponent implements OnInit {

  @Input() formParent: RxFormGroup;
  @Input() label: string;
  @Input() isLabelTop: false;
  @Input() frmControl: string;
  @Input() options: any;
  @Input() placeHolder: string;
  @Input() isUser = false;
  @Input() isPaymentList = false;

  @Output() value = new EventEmitter<any>();  
  control: any;
  placeholder = '';
  
  constructor() { }

  ngOnInit(): void {
    this.placeholder = this.placeHolder ? this.placeHolder : '';
    this.control = this.formParent.controls[this.frmControl];
  }

  onCheckboxChange(isChecked: boolean): void {
    this.control.setValue(isChecked);
    this.value.emit(this.control.value);
  }

}
